
import { createAction, props } from '@ngrx/store';
import { IProfilePayload, LoginData } from './../interfaces/profile';

export const login = createAction('[Auth] Login User', props<LoginData>());

export const fetchUserSuccess = createAction(
  '[Auth] Get User Data Success',
  props<IProfilePayload & { 
    vcRazonSocial: string; 
    iIdEmpresa: number; 
    siEstadoCredito: number;
    siEstadoCotizacion: number;
    siAccesoalaWeb: number;
    vcMensajeCliente: string;
    siFormaAprobarValorizacion: number;
    iIdCotiEmpresa: number;
    iVersion: number,
    bCargaValorizacionesaContratas: boolean;
    bPedirPDFSolicitudEnCita: boolean;
    iIdFormatoSolitudEMO: number; }>()
);

export const fetchUserSuccessNoAccess = createAction(
  '[Auth] Get User Data Success But A Company Doesn´t have access',
  props<IProfilePayload & { 
    vcRazonSocial: string; 
    iIdEmpresa: number;
    siEstadoCredito: number;
    siEstadoCotizacion: number;
    siAccesoalaWeb: number;
    vcMensajeCliente: string; 
    siFormaAprobarValorizacion: number;
    iIdCotiEmpresa: number;
    iVersion: number;
    bCargaValorizacionesaContratas: boolean;
    bPedirPDFSolicitudEnCita: boolean;
    iIdFormatoSolitudEMO: number;
    errorMsg: string; }>()
);

export const setCompanyId = createAction(
  '[User] Set company',
  props<{ id: number | null;  
    name: string | null; 
    siEstadoCredito: number | null;
    siEstadoCotizacion: number | null;
    siAccesoalaWeb: number | null;
    vcMensajeCliente: string | null; 
    siFormaAprobarValorizacion: number | null;
    iIdCotiEmpresa: number | null;
    iVersion: number | null;
    bCargaValorizacionesaContratas: boolean | null;
    bPedirPDFSolicitudEnCita: boolean | null;
    iIdFormatoSolitudEMO: number | null;  }>()
);

export const logOut = createAction('[Auth] Log Out');

export const fetchUserFailure = createAction('[Auth] Get User Data Failure');

export const fetchUserFailureNoAccess = createAction(
  '[Auth] Get User Data Failure All Companies Don´t have access'
);

export const fetchUserFailureAdmin = createAction('[Auth] Get User Data Failure Admin');

export const setClinicId = createAction(
  '[User] Set Clinic',
  props<{ iIdSede: number, vcNombreSede: string }>()
);

export const setSiWeb = createAction(
  '[User] Set SiWeb',
  props<{ siWeb: number }>()
);

export const setClientId = createAction(
  '[User] Set Client',
  props<{ iIdClient: number, vcClient: string }>()
);

export const setProviderId = createAction(
  '[User] Set Provider',
  props<{ iIdProvider: number, vcProvider: string }>()
);

export const setRoles = createAction(
  '[User] Set roles',
  props<{ roles: number[] }>()
);

export const profileActions = {
  fetchUserSuccess,
  fetchUserFailure,
  fetchUserSuccessNoAccess,
  fetchUserFailureNoAccess,
  fetchUserFailureAdmin
};